import { Parse } from "parse";

Parse.initialize(
  process.env.REACT_APP_APP_ID,
  null,
  process.env.REACT_APP_MASTER_KEY
);
Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
Parse.serverURL = process.env.REACT_APP_SERVER_URL;

export async function getAllDescendantUsers(gameOwnerId) {
  const allUsers = [];

  async function recurse(managerId) {
    const q = new Parse.Query(Parse.User);
    q.equalTo("manager", {
      __type: "Pointer",
      className: "_User",
      objectId: managerId,
    });
    q.limit(1000);
    const results = await q.find({ useMasterKey: true });

    allUsers.push(...results);
    for (const user of results) {
      await recurse(user.id); // Recursively get agents/players etc
    }
  }

  await recurse(gameOwnerId);
  return allUsers;
}

export const fetchTransactions = async (filter = {}) => {
    const { startDate, endDate, users } = filter;
  
    if (!users[0]?.id) {
      return {
        totalRecharge: 0,
        totalRedeem: 0,
        totalWinAmount: 0,
        totalBetAmount: 0,
      };
    }
  
    let adjustedEndDate = null;
  if (endDate) {
    adjustedEndDate = new Date(endDate);
    adjustedEndDate.setUTCHours(23, 59, 59, 999); // ✅ UTC safe
}

    const userId = users[0].id;
    const userRole = users[0].role?.toLowerCase?.(); // Safe fallback
  
    // ✅ Role-based match logic
    const matchExpr =
      userRole === "player"
        ? { $in: [userId, "$_rperm"] } // Just included anywhere
        : {
            $and: [
              { $in: [userId, "$_rperm"] },
              { $ne: [{ $arrayElemAt: ["$_rperm", 0] }, userId] }, // Not first
            ],
          };
  
    const matchStage = {
      $expr: matchExpr,
    };
    const dateFilter = {};
    if (startDate) {
      dateFilter.createdAt = { ...dateFilter.createdAt, $gte: new Date(startDate) };
    }
    if (adjustedEndDate) {
      dateFilter.createdAt = { ...dateFilter.createdAt, $lte: adjustedEndDate };
    }
  
    const txnPipeline = [
      { $match: { ...dateFilter } },
      { $match: matchStage },
      {
        $group: {
          _id: "$txn_type",
          totalAmount: { $sum: "$amount" },
        },
      },
    ];
  
    const txnQuery = new Parse.Query("Transactions");
    const txnResult = await txnQuery.aggregate(txnPipeline, { useMasterKey: true });
  
    let totalRecharge = 0;
    let totalRedeem = 0;
  
    txnResult.forEach((entry) => {
      if (entry.objectId === 0) totalRecharge = entry.totalAmount;
      if (entry.objectId === 1) totalRedeem = entry.totalAmount;
    });
  
    const netAmount = totalRecharge - totalRedeem;
    const rechargeRatio =
      totalRecharge === 0 ? 0 : (netAmount / totalRecharge) * 100;
  
    // ===================== GameCoins Aggregation =====================
    const gameCoinsPipeline = [
      { $match: { ...dateFilter } },
      { $match: matchStage },
      {
        $group: {
          _id: null,
          totalBetAmount: { $sum: "$totalBetAmount" },
          totalWinAmount: { $sum: "$totalWinAmount" },
        },
      },
    ];
  
    const coinsQuery = new Parse.Query("GameCoins");
    const coinsResult = await coinsQuery.aggregate(gameCoinsPipeline, { useMasterKey: true });
  
    let totalBetAmount = 0;
    let totalWinAmount = 0;
  
    if (coinsResult.length > 0) {
      totalBetAmount = coinsResult[0].totalBetAmount || 0;
      totalWinAmount = coinsResult[0].totalWinAmount || 0;
    }
  
    // ===================== Final Return =====================
    return {
      totalRecharge,
      totalRedeem,
      totalBetAmount,
      totalWinAmount,
      rechargeRatio,
    };
  };
  
  
  
